let initialState = {}

const auth = (state = initialState, action) => {
    switch (action.type) {
        case 'LOGGING_IN':
            return {
                ...state,
                pending: action.data,
                failed: false,
                expired: false,
            }
        case 'LOGIN_SUCCESS':
            return {
                ...state,
                pending: false,
                failed: false,
                expired: false,
            }
        case 'LOGIN_FAILED':
            return {
                ...state,
                pending: false,
                failed: true,
                expired: false,
            }
        case 'LOGIN_EXPIRED':
            return {
                ...state,
                pending: false,
                failed: false,
                expired: true,
            }
        case 'CS_TRACK':
            return {
                ...state,
                lastDailyLogin: action.data
            }
        default:
            return state
    }
}

export default auth
